module.exports = __webpack_public_path__ + "static/media/plus_circle.4e2aa91e.svg";